import React, { FC } from 'react';

import { IconProps } from 'types/components';

import CardIcon from './CardIcon';

const VisaCard: FC<IconProps> = (props) => (
  <CardIcon {...props}>
    <rect width="208" height="134" x="1" y="1" fill="#e7ebfa" rx="24" />
    <path fill="#d6dce5" d="M185 136H25a25 25 0 0 1-25-25V25A25 25 0 0 1 25 0h160a25 25 0 0 1 25 25v86a25 25 0 0 1-25 25ZM25 1A24 24 0 0 0 1 25v86a24 24 0 0 0 24 24h160a24 24 0 0 0 24-24V25a24 24 0 0 0-24-24Z" />
    <path fill="#1434cb" d="M103.73 46.16 94 91.51H82.29L92 46.16Zm49.36 29.29 6.17-17 3.56 17Zm13.09 16.06H177l-9.47-45.35h-10a5.33 5.33 0 0 0-5 3.33l-17.6 42h12.32l2.44-6.77h15l1.42 6.77Zm-30.62-14.8c.05-12-16.55-12.63-16.44-18 0-1.63 1.59-3.36 5-3.8a22.09 22.09 0 0 1 11.56 2l2.06-9.62a31.59 31.59 0 0 0-11-2c-11.6 0-19.76 6.17-19.83 15-.07 6.52 5.83 10.17 10.27 12.34s6.11 3.65 6.09 5.63c0 3-3.65 4.39-7 4.44a24.58 24.58 0 0 1-12-2.86l-2.13 9.93a35.41 35.41 0 0 0 13 2.41c12.32.04 20.38-6.05 20.42-15.47ZM87 46.16 68 91.51H55.55L46.2 55.32c-.57-2.23-1.06-3-2.79-4a49.15 49.15 0 0 0-11.57-3.86l.28-1.32h20a5.48 5.48 0 0 1 5.41 4.63L62.43 77l12.21-30.87Z" />
  </CardIcon>
);

export default VisaCard;
